module.exports = __webpack_public_path__ + "img/title1.5ddc2577.png";